import React from 'react';

const SkeletonLoader = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      height: '100vh',
      backgroundColor: '#f5f5f5',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header */}
      <div style={{
        height: '60px',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        paddingLeft: '24px',
        paddingRight: '24px',
        borderBottom: '1px solid #e0e0e0',
        gap: '32px'
      }}>
        {/* Logo */}
        <div style={{
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '16px',
          animation: 'pulse 1.5s ease-in-out infinite'
        }}>
          <img
            src="/logo.svg"
            alt="Logo"
            style={{
              height: '32px',
              opacity: 0.7
            }}
          />
        </div>

        {/* Nav Items */}
        <div style={{ display: 'flex', gap: '24px', flex: 1 }}>
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              style={{
                width: '80px',
                height: '20px',
                backgroundColor: '#e0e0e0',
                borderRadius: '4px',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.1}s`
              }}
            />
          ))}
        </div>

        {/* Search */}
        <div style={{
          width: '200px',
          height: '36px',
          backgroundColor: '#f5f5f5',
          borderRadius: '4px',
          animation: 'pulse 1.5s ease-in-out infinite'
        }} />

        {/* Right Icons */}
        <div style={{ display: 'flex', gap: '16px' }}>
          {[...Array(3)].map((_, i) => (
            <div
              key={i}
              style={{
                width: '32px',
                height: '32px',
                backgroundColor: '#e0e0e0',
                borderRadius: '50%',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.1}s`
              }}
            />
          ))}
        </div>
      </div>

      {/* Content */}
      <div style={{ padding: '24px', flex: 1, overflow: 'auto' }}>
        {/* Filter Pills */}
        <div style={{
          display: 'flex',
          gap: '12px',
          marginBottom: '24px',
          flexWrap: 'wrap'
        }}>
          {[...Array(6)].map((_, i) => (
            <div
              key={i}
              style={{
                width: `${80 + Math.random() * 60}px`,
                height: '36px',
                backgroundColor: '#e0e0e0',
                borderRadius: '18px',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.1}s`
              }}
            />
          ))}
        </div>

        {/* Tabs & Filters */}
        <div style={{
          display: 'flex',
          gap: '16px',
          marginBottom: '24px',
          alignItems: 'center'
        }}>
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              style={{
                width: '100px',
                height: '32px',
                backgroundColor: '#e0e0e0',
                borderRadius: '6px',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.1}s`
              }}
            />
          ))}
          <div style={{ flex: 1 }} />
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              style={{
                width: '120px',
                height: '36px',
                backgroundColor: '#e0e0e0',
                borderRadius: '4px',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.1}s`
              }}
            />
          ))}
        </div>

        {/* Table Header */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '40px 60px 140px 80px 100px 100px 100px 80px 80px 80px 100px 100px 100px 100px 100px 80px 80px',
          gap: '8px',
          padding: '12px 16px',
          backgroundColor: '#f0f0f0',
          borderRadius: '8px 8px 0 0',
          fontSize: '12px',
          fontWeight: '600'
        }}>
          {[...Array(17)].map((_, i) => (
            <div
              key={i}
              style={{
                height: '16px',
                backgroundColor: '#d0d0d0',
                borderRadius: '3px',
                animation: 'pulse 1.5s ease-in-out infinite',
                animationDelay: `${i * 0.05}s`
              }}
            />
          ))}
        </div>

        {/* Table Rows */}
        {[...Array(12)].map((_, rowIndex) => (
          <div
            key={rowIndex}
            style={{
              display: 'grid',
              gridTemplateColumns: '40px 60px 140px 80px 100px 100px 100px 80px 80px 80px 100px 100px 100px 100px 100px 80px 80px',
              gap: '8px',
              padding: '16px',
              backgroundColor: '#6b7280',
              marginBottom: '8px',
              borderRadius: '6px',
              alignItems: 'center'
            }}
          >
            {/* Checkbox */}
            <div style={{
              width: '18px',
              height: '18px',
              backgroundColor: '#4b5563',
              borderRadius: '3px',
              animation: 'pulse 1.5s ease-in-out infinite',
              animationDelay: `${rowIndex * 0.05}s`
            }} />

            {/* Cells */}
            {[...Array(16)].map((_, colIndex) => (
              <div
                key={colIndex}
                style={{
                  height: colIndex === 3 ? '24px' : '16px',
                  backgroundColor: colIndex === 3 ? '#10b981' : '#9ca3af',
                  borderRadius: colIndex === 3 ? '12px' : '3px',
                  width: colIndex === 3 ? '24px' : '100%',
                  animation: 'pulse 1.5s ease-in-out infinite',
                  animationDelay: `${(rowIndex * 16 + colIndex) * 0.02}s`
                }}
              />
            ))}
          </div>
        ))}
      </div>

      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.6;
          }
        }
      `}</style>
    </div>
  );
};

export default SkeletonLoader;